<template>
    <div id="mapElementId" class="h-100">
        <GmapMap :center="center" :zoom="12" ref="mapRef" class="map-size">
            <GmapPolyline :path="mapPolyline" v-bind:options="{ strokeColor:'#2e8ee8'}" />
            <GmapMarker 
                v-bind:key="markerKey"
                v-for="(m, markerKey) in markers"
                :position="m"
                :label="markers[markerKey].label"
                @click="center=m"
            />
        </GmapMap>
    </div>
</template>

<script>
export default {
    name: "GoogleMap",
    watch: {
        mapPolyline: function(val) {
            if (val.length) {
                this.setMarkers(val);
                var bounds = new window.google.maps.LatLngBounds();
                    for (var i = 0; i < val.length; i++) {
                        bounds.extend(val[i]);
                    }
                this.map.fitBounds(bounds);
            } else {
                this.$store.commit('setAlert', {
                    title: this.$gettext("Error calculating the route"),
                    text: this.$gettext("The route could not be displayed on the map."),
                    variant: "error",
                    duration: 4
                });
            }
        }
    },
    data() {
        return {
            center: { lat: 52.37, lng: 4.89 },  // Amsterdam default
            map: undefined,
            origin: null,
            destination: null,
            travelMode: null,
            markers: [],
            markerKey: 0
        }
    },
    mounted() {
        this.$refs.mapRef.$mapPromise.then((map) => {
            this.map = map;
        });
    },
    methods: {
        setMarkers(val) {
            this.markers = [
                {
                    lat: val[0].lat(),
                    lng: val[0].lng(),
                    label: 'A'
                },
                {
                    lat: val[val.length - 1].lat(),
                    lng: val[val.length - 1].lng(),
                    label: 'B'
                }
            ]
        },
        swapMarkers() {
            if (this.markers.length) {
                if (this.markers[0].label === 'A')
                    this.markers[0].label = 'B';
                else
                    this.markers[0].label = 'A';

                if (this.markers[1].label === 'A')
                    this.markers[1].label = 'B';
                else
                    this.markers[1].label = 'A';
            }
        }
    },
    computed: {
        mapPolyline() {
            return this.$store.getters['tripStore/getMapPolyline'];
        }
    }
}
</script>

<style scoped>
.map-size {
    width: 100%;
    height: 100%;
}
.vue-map-container {
  position: relative;
}
.vue-map-container .vue-map {
  left: 0; right: 0; top: 0; bottom: 0;
  position: absolute;
}
.vue-map-hidden {
  display: none;
}
.vue-street-view-pano-container {
  position: relative;
}
.vue-street-view-pano-container .vue-street-view-pano {
  left: 0; right: 0; top: 0; bottom: 0;
  position: absolute;
}
</style>
